module.exports = __webpack_public_path__ + "static/media/bg_pattern_blanc.39eff4bc.png";